import { render, staticRenderFns } from "./aircraft.vue?vue&type=template&id=87005246"
import script from "./aircraft.vue?vue&type=script&lang=js"
export * from "./aircraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports